import { faCog } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function CogIcon(props) {
  return (
      <Icon
        size="2x"
        {...props}
        icon={faCog}
      />
  );
}
